module.exports = __webpack_public_path__ + "static/media/returns_V.6c0e6d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/returns_V.png
// module id = 106
// module chunks = 0